<template>
  <div class="hidden lg:flex lg:col-span-3 xl:col-span-2 3xl:col-span-1 bg-slate-900 flex-col">
    <div class="text-white flex flex-grow flex-col justify-between">
      <div v-if="agentView === false">
        <div class="py-8 px-4 border-b border-slate-700">
          <router-link
            to="/admin/teams?sort=created&order=desc&status=Active"
            class="flex items-center text-slate-300 hover:text-slate-100 px-2 py-2 rounded-lg"
          >
            <vue-feather type="home" class="h-4 mr-1" />
            Teams
          </router-link>
          <router-link
            to="/admin/budget_requests?sort=created&order=desc&status=Pending"
            class="flex items-center mt-3 text-slate-300 hover:text-slate-100 px-2 py-2 rounded-lg"
          >
            <vue-feather type="bookmark" class="h-4 mr-1" />
            Budget Update Requests
          </router-link>
        </div>
      </div>
      <div class="p-8 border-t border-slate-700">
        <div class="flex items-center w-full">
          <router-link v-if="$store.state.general.teamSetupProgress >= 100" to="/settings/account/profile">
            <div class="h-8 w-8 mr-3 rounded-full flex items-center justify-center bg-[#fde68a] text-slate-900">
              {{ $store.state.general.currentUserAccountDetails.username.charAt(0).toUpperCase() }}
            </div>
          </router-link>
          <router-link v-else to="/settings">
            <RadialProgress
              class="text-white mr-2"
              style="--size: 2rem; font-size: 0.5rem"
              :progress="$store.state.general.teamSetupProgress"
            />
          </router-link>
          <div class="flex flex-col text-left text-sm text-ellipsis overflow-hidden">
            {{ $store.state.general.currentUserAccountDetails.username }}
            <div
              class="cursor-pointer inline-block text-xs leading-4 font-medium text-slate-400 group-hover:text-gray-700 transition ease-in-out duration-150"
              @click="signOut"
            >
              Sign out
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RadialProgress from '../../shared/RadialProgress.vue';

export default {
  components: {
    RadialProgress,
  },
  computed: {
    agentView() {
      return this.$store.state.general.currentUserAccountDetails.role === 'Agent';
    },
  },
  methods: {
    signOut() {
      fetch('/users/sign_out', {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-TOKEN': document.querySelectorAll('[name="csrf-token"]')[0].content,
        },
      })
        .then(response => {})
        .then(data => {
          window.location.href = '/';
        });
    },
  },
};
</script>

<!-- duplicated in MobileSidebar -->
<style scoped>
@reference "tailwindcss";
.router-link-exact-active.router-link-active {
  @apply bg-slate-800 font-bold text-white;
}
</style>
